import { AccountAppType } from '../common/enums/account-app-type';

export default function getAppTypeFromPrefix(appPrefix: string): AccountAppType {
  return appPrefix === 'agent' ? AccountAppType.AgentSnap : AccountAppType.ClaimSnap;
}
